
import { Component, OnInit } from '@angular/core';
import { DocumentDto } from '@models/protocols/document.dto';
import { DocumentService } from '@services/document.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileSelectEvent, FileUploadHandlerEvent } from 'primeng/fileupload';

@Component({
  selector: 'ebs-document-creation-dialog',
  templateUrl: './document-creation-dialog.component.html',
  styleUrls: ['./document-creation-dialog.component.scss'],
})
export class DocumentCreationDialogComponent implements OnInit {
  document!: DocumentDto;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private documentService: DocumentService,
  ) {}

  ngOnInit() {
    if (this.config.data.document !== undefined) {
      this.document = this.config.data.document;
    } else {
      this.document = {
        hasProtocol: false,
        isSigned: false,
        mimeType: '',
        name: '',
      };
    }
  }

  async onBasicUploadAuto(event: FileUploadHandlerEvent) {
    this.documentService
      .uploadFile(this.document, await event.files[0].arrayBuffer())
      .subscribe(() => this.ref.close(true));
  }

  onFileSelected(event: FileSelectEvent) {
    this.document.mimeType = event.files[0].type;
    this.document.name = event.files[0].name;
  }
}
